module.exports = __webpack_public_path__ + "img/full0-min.524d11a2.png";